import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useUser } from '../UserContext';
import './index.css';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import logo from '../../imagens/Sem fundo.png';
import { NumericInput } from './numericInput'; 
import { Checkbox } from '@mui/material';

const Venda = () => {
  const navigate = useNavigate();
  const { userInfo, setUserInfo } = useUser();
  //const [userInfo, setUserInfo] = useState({ ...useUser().userInfo });

  const [loadingPedidos, setLoadingPedidos] = useState(true);
  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState(null);
  const [showClienteInfo, setShowClienteInfo] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState('');
  const [paymentTerms, setPaymentTerms] = useState(['', '', '', '', '', '']);
  const [receber, setReceber] = useState([]);
  const [financeiroAtrasado, setFinanceiroAtrasado] = useState([]);

  const [produtos, setProdutos] = useState([]);
  const [order, setOrder] = useState({});
  const [orderItems, setOrderItems] = useState([]);
  const [expandedProducts, setExpandedProducts] = useState({});
  const [searchProduto, setSearchProduto] = useState('');
  const [estoqueProdutos, setEstoqueProdutos] = useState({}); 
  const [jaIncluido, setJaIncluido] = useState(false); // Novo estado para controlar a exibição de itens do pedido

  const [showModal, setShowModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [dataEntrega, setDataEntrega] = useState('');
  const [desconto, setDesconto] = useState('');
  const [descontoBoleto, setDescontoBoleto] = useState('');
  const [taxaEntrega, setTaxaEntrega] = useState('');
  const [NFE_OBS_PEDIDO, setNFE_OBS_PEDIDO] = useState('');

  const [abaSelecionada, setAbaSelecionada] = useState("Produtos");
  const [mixProdutos, setMixProdutos] = useState([]);

  const [tabelas, setTabelas] = useState([]);
  const [precosTabela, setPrecosTabela] = useState({});
  const [tabelaSelecionada, setTabelaSelecionada] = useState(selectedCliente?.tabId || null);
  const [orcamentosSalvos, setOrcamentosSalvos] = useState([]);
  const [showOrcamentos, setShowOrcamentos] = useState(false);
  const [contadorOrdem, setContadorOrdem] = useState(1);

  //Comissao calculo em tela
  const [infoComissaoProduto, setInfoComissaoProduto] = useState({});

  //edição
  const [pedidos, setPedidos] = useState([]);
  const [pedidoSelecionado, setPedidoSelecionado] = useState(null);
  const [itensPedido, setItensPedido] = useState([]);

  //Controla itens editados
  const [itensRemovidos, setItensRemovidos] = useState([]);
  const [itensEditados, setItensEditados] = useState([]);
  const [showPedidosEdicao, setShowPedidosEdicao] = useState(false);

  useEffect(() => {
  //console.log("selectedCliente:", selectedCliente);
  //console.log("searchTerm:", searchTerm);
}, [selectedCliente, searchTerm]);

  // Redireciona se não estiver logado
// Redireciona se não estiver logado ou fora do horário
useEffect(() => {
  if (!userInfo?.username) {
    localStorage.removeItem('userInfo');
    navigate('/');
    return;
  }

  // Se bloqueio por horário estiver ativo
  if (userInfo.bloqueioHorario === 'T') {
    const agora = new Date();
    const horaAtual = agora.getHours();
    const minutoAtual = agora.getMinutes();

    // Converte strings "HH;MM" para números
    const [horaIni, minutoIni] = userInfo.horaInicioLiberado.split(';').map(Number);
    const [horaFim, minutoFim] = userInfo.horaFinalLiberado.split(';').map(Number);

    // Calcula minutos do dia
    const minutosAtuais = horaAtual * 60 + minutoAtual;
    const minutosInicio = horaIni * 60 + minutoIni;
    const minutosFim = horaFim * 60 + minutoFim;

    // Se fora do intervalo permitido
    if (minutosAtuais < minutosInicio || minutosAtuais > minutosFim) {
      alert(`Sistema disponível apenas entre ${horaIni}:${String(minutoIni).padStart(2, '0')} e ${horaFim}:${String(minutoFim).padStart(2, '0')}.`);
      navigate('/menu');
    }
  }
  }, [userInfo, navigate]);

  
  // Removido useEffect fora do componente
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (selectedCliente || (orderItems && orderItems.length > 0)) {
        e.preventDefault();
        e.returnValue = '';
        return '';
      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [selectedCliente, orderItems]);

  useEffect(() => {
  const formaVista = ['DINHEIRO', 'PIX', 'DEBITO'];
  const pm = (paymentMethod || '').toUpperCase();

  if (formaVista.includes(pm)) {
    setPaymentTerms(['', '', '', '', '', '']);
    return;
  }

  const prazoStr = selectedCliente?.prazo || '';
  if (prazoStr) {
    const prazosArray = prazoStr.split(',').map((p) => p.trim()).slice(0, 6);
    while (prazosArray.length < 6) prazosArray.push('');
    setPaymentTerms(prazosArray);
  } else {
    setPaymentTerms(['', '', '', '', '', '']);
  }
}, [paymentMethod, selectedCliente]);

  const credentials = btoa(`${userInfo.alias};${userInfo.venLogin}:${userInfo.venSenha}`);

  // Busca clientes e produtos
  useEffect(() => {
    const fetchClientes = async () => {
      try {
        setLoadingPedidos(true);
        const res = await fetch(`${userInfo.url}/cliente/WenAPP/vendedor/${userInfo.ven_id}`, {
          headers: {
            'Content-Type': 'application/json',
            'empresa': userInfo.alias,
            'Authorization': `Basic ${credentials}`,
          },
        });
        const text = await res.text();
        try {
          const json = JSON.parse(text);
          setClientes(json);
        } catch (e) {
          console.error('Erro ao converter clientes para JSON:', e);
        }
      } catch (err) {
        console.error('Erro ao buscar clientes:', err);
      } finally {
        setLoadingPedidos(false);
      }
    };

    const fetchProdutos = async () => {
      try {
        const res = await fetch(`${userInfo.url}/produto/WenAPP`, {
          headers: {
            'Content-Type': 'application/json',
            'empresa': userInfo.alias,
            'Authorization': `Basic ${credentials}`,
          },
        });
        const text = await res.text();
        try {
          const json = JSON.parse(text);
          setProdutos(json);
        } catch (e) {
          console.error('Erro ao converter produtos para JSON:', e);
        }
      } catch (err) {
        console.error('Erro ao buscar produtos:', err);
      }
    };

    fetchClientes();
    fetchProdutos();
  }, [userInfo, credentials]);

  // Busca o mix somente se estiver na aba Mix e já tiver cliente selecionado
  useEffect(() => {
    if (selectedCliente?.cliId) {
      fetch(`${userInfo.url}/cliente/WenAPP/mixvenda/${selectedCliente.cliId}`, {
          headers: {
            'Content-Type': 'application/json',
            'empresa': userInfo.alias,
            'Authorization': `Basic ${credentials}`,
          },
        })
        .then(res => res.json())
        .then(dataMix => {
          const mixComDetalhes = dataMix.map(mixItem => {
            const produto = produtos.find(p => p.proId === mixItem.proId);
            return {
              ...produto,
              qtdPeriodo: mixItem.qtdPeriodo,
              vlrUltVenda: mixItem.vlrUltVenda
            };
          });
          setMixProdutos(mixComDetalhes);
        })
        .catch(err => console.error("Erro ao buscar mix:", err));
    }
  }, [abaSelecionada, produtos, userInfo, selectedCliente, credentials]);

  useEffect(() => {
    if (userInfo.tabelaPreco === "T") {
      const fetchTabelas = async () => {
        try {
          // Busca tabelas
          const resTab = await fetch(`${userInfo.url}/tabelas/`, {
            headers: {
              'Content-Type': 'application/json',
              'empresa': userInfo.alias,
              'Authorization': `Basic ${credentials}`,
            },
          });
          const dataTab = await resTab.json();
          setTabelas(dataTab);

          // Busca preços de todas as tabelas
          const precosOrganizados = {};
          await Promise.all(
            dataTab.map(async (tab) => {
              const res = await fetch(`${userInfo.url}/tabelasproduto/produtos/${tab.tabId}`, {
                headers: {
                  'Content-Type': 'application/json',
                  'empresa': userInfo.alias,
                  'Authorization': `Basic ${credentials}`,
                },
              });
              const data = await res.json();
              data.forEach((p) => {
                if (!precosOrganizados[tab.tabId]) {
                  precosOrganizados[tab.tabId] = {};
                }
                precosOrganizados[tab.tabId][p.proId] = p.tapVlrVenda;
              });
            })
          );
          setPrecosTabela(precosOrganizados);
        } catch (err) {
          console.error("Erro ao carregar tabelas de preço:", err);
        }
      };
      fetchTabelas();
    }
  }, [userInfo, credentials]);

  useEffect(() => {
    if (selectedCliente?.tabId) {
      setTabelaSelecionada(selectedCliente.tabId);
    } else {
      setTabelaSelecionada('');
    }
  }, [selectedCliente]);

  // Filtra clientes para autocomplete
  const filteredClientes = clientes.filter((c) => {
    const termo = searchTerm.toLowerCase();

    return (
      c.cliId?.toString().includes(termo) ||                // Código      
      c.colNome?.toLowerCase().includes(termo) ||           // Nome
      c.colFantasia?.toLowerCase().includes(termo) ||           // fantasia
      c.colCnpjCpf?.toLowerCase().includes(termo)        // CNPJ/CPF
      
    );
  });

    // Seleciona cliente e ajusta pagamento e prazos
    const handleSelectCliente = (cliente) => {
        //console.log("Cliente selecionado:", cliente);
      setSelectedCliente(cliente);
      setOrder({}); // Limpa o carrinho ao trocar de cliente
      setOrderItems([]); // Limpa os itens do carrinho ao trocar de cliente
      setPaymentMethod(cliente.pagDescricao);
      setSearchTerm(cliente.colNome)
      setShowSuggestions(false);
      setInfoComissaoProduto({}); // Limpa informações de comissão ao trocar de cliente

    if (userInfo.bloqFinanceiro === 'T' && cliente.vencido === 'T') {
      alert('Cliente com pendências financeiras. Operação bloqueada.');
    } else if (cliente.vencido === 'T') {
      alert('Cliente com pendências financeiras.');
    }
    };

  // toda vez que um cliente é selecionado, buscar o financeiro dele
  useEffect(() => {
    if (selectedCliente?.cliId) {
      fetch(`${userInfo.url}/receber/cliente/${selectedCliente.cliId}`, {
          headers: {
            'Content-Type': 'application/json',
            'empresa': userInfo.alias,
            'Authorization': `Basic ${credentials}`,
          },
        })
        .then(res => res.json())
        .then(data => {
          setFinanceiroAtrasado(data);
        })
        .catch(err => console.error(err));
    }
  }, [userInfo, selectedCliente, credentials]);

  // Atualiza prazo individualmente
  const handleTermChange = (index, value) => {
    const updated = [...paymentTerms];
    updated[index] = value;
    setPaymentTerms(updated);
  };

  useEffect(() => {
    if (selectedCliente?.pagDescricao) {
      setPaymentMethod(selectedCliente.pagDescricao.toUpperCase());
    }
  }, [selectedCliente])

  const handleTermBlur = (index, value) => {
  for (let i = 0; i < paymentTerms.length; i++) {
    const val = Number(paymentTerms[i]);
    
    // 1° - Para BOLETO ou CARTEIRA, o primeiro campo deve ser maior que 0
    if ((paymentMethod === "BOLETO" || paymentMethod === "CARTEIRA") && i === 0 && val <= 0) {
      alert("Para BOLETO ou CARTEIRA, o primeiro prazo deve ser maior que 0 dias!");
      return;
    };
    
    // 2° - Se houver parcela anterior preenchida, a atual deve ser maior
    if (i > 0 && paymentTerms[i] !== '' && paymentTerms[i] != null) {
      const valorAnterior = Number(paymentTerms[i - 1]);
      // Só valida se a parcela anterior está preenchida
      if (paymentTerms[i - 1] !== '' && paymentTerms[i - 1] != null && val <= valorAnterior) {
        alert("O prazo da parcela deve ser maior que o anterior!");
        return;
      }
    }
  }
  };

  //Consulta pedidos para edição
   const listarPedidos = async () => {
    setLoadingPedidos(true);
    const credentials = btoa(`${userInfo.user}:${userInfo.password}`);
    const res = await fetch(`${userInfo.url}/nfe`, {
      headers: {
        'Content-Type': 'application/json',
        'empresa': userInfo.alias,
        'Authorization': `Basic ${credentials}`,
        'venId': userInfo.ven_id,
      }
    });
    const data = await res.json();
    // Filtra apenas os pedidos com libEdicao === "T"
    const pedidosEditaveis = data.filter(pedido => pedido.libEdicao === "T");
    setPedidos(pedidosEditaveis);
    setLoadingPedidos(false);
  };

  //consulta itens do pedido selecionado
  const selecionarPedido = async (nfeId) => {
    const pedido = pedidos.find(p => p.nfeId === nfeId);
    setPedidoSelecionado(pedido);

    const clienteDoPedido = clientes.find(c => c.cliId === pedido.cliId);
    setSelectedCliente(clienteDoPedido);
    setDataEntrega(pedido.nfeDtaEntrega ? pedido.nfeDtaEntrega.split('T')[0] : '');
    setNFE_OBS_PEDIDO(pedido.observacao || '');
    setSearchTerm(clienteDoPedido ? clienteDoPedido.colFantasia : '');

    // Preenche a data de entrega
    setDataEntrega(pedido.nfeDtaEntrega ? pedido.nfeDtaEntrega.split('T')[0] : '');

    const credentials = btoa(`${userInfo.user}:${userInfo.password}`);
    const res = await fetch(`${userInfo.url}/itemnfe/pedido/${nfeId}`, {
      headers: {
        'Content-Type': 'application/json',
        'empresa': userInfo.alias,
        'Authorization': `Basic ${credentials}`,
        'venId': userInfo.ven_id,
      }
    });

    const text = await res.text();
    try {
      const data = JSON.parse(text);
      setItensPedido(data);

      // Preenche o estado order com as quantidades, valores e embalagem dos itens do pedido
      const novoOrder = {};
      data.forEach(item => {
        novoOrder[item.proId] = {
          quantidade: item.infeQtdProduto,
          preco: item.infeVlrProduto, // valor do item
          embalagem: item.infeUnidade,
          ordem: item.infeOrdem,
        };
      });
      setOrder(novoOrder);

    } catch (e) {
      console.error("Erro ao converter para JSON:", e, text);
    }
  };

// Modifique o handleQuantityChange para ser mais claro
  const handleQuantityChange = (proId, value) => {
    let quantidade = parseFloat(value) || 0;
    const prod = produtos.find((p) => p.proId === proId);

    if (userInfo.controlaEstoque === 'T' && prod && quantidade > prod.proQtdEstoque) {
      quantidade = prod.proQtdEstoque;
    }

    setOrder((prev) => {
      const itemAtual = prev[proId] || {};
      const tinhaQuantidade = itemAtual.quantidade > 0;
      const temQuantidadeAgora = quantidade > 0;

      let novaOrdem = itemAtual.ordem;
      if (!tinhaQuantidade && temQuantidadeAgora) {
        novaOrdem = contadorOrdem;
        setContadorOrdem(c => c + 1);
        //console.log(`🎯 Adicionando ${prod?.proDescricao} com ordem ${novaOrdem}`);
      }

      return {
        ...prev,
        [proId]: {
          ...itemAtual,
          quantidade,
          ordem: novaOrdem,
        },
      };
    });

    // Atualiza itensEditados se estiver editando um pedido
    if (pedidoSelecionado) {
      const itemOriginal = itensPedido.find(item => item.proId === proId);
      if (itemOriginal && itemOriginal.infeId) {
        setItensRemovidos(prev => prev.includes(itemOriginal.infeId) ? prev : [...prev, itemOriginal.infeId]);
      }
      if (quantidade > 0) {
        // Adiciona o novo item para POST
        setItensEditados(prev => {
          const jaExiste = prev.some(item => item.proId === proId);
          const precoFinal = order[proId]?.preco ?? (
            userInfo.tabelaPreco === "T" && tabelaSelecionada
              ? precosTabela[tabelaSelecionada]?.[prod.proId] ?? prod.proVlrVenda
              : prod.proVlrVenda
          );
          const novoItem = {
            proId: prod.proId,
            proDescricao: prod.proDescricao,
            infeQtdProduto: quantidade,
            infeUnidade: order[proId]?.embalagem || prod.embUnidade,
            infeVlrProduto: precoFinal,
            infeVlrLiquido: precoFinal,
            ncmId: prod.ncmId,
            infeOrdem: order[proId]?.ordem,
            proVlrCompra: prod.proVlrCompra,
            proVlrCusto: prod.proVlrCusto,
            proVlrVenda: prod.proVlrVenda,
            proPerComissao: prod.proPerComissao,
          };
          console.log("Item editado montado:", novoItem)
          if (jaExiste) {
            return prev.map(item => item.proId === proId ? novoItem : item);
          } else {
            return [...prev, novoItem];
          }
        });
      } else {

        setItensEditados(prev => prev.filter(item => item.proId !== proId));
        if (userInfo.tabelaPreco === "T" && !tabelaSelecionada) {
          alert('Selecione uma tabela de preços antes de adicionar produtos.');
          return;
        }
      }
    }
  };

  // Controla preço
  const handlePriceChange = (id, val) =>
    setOrder((prev) => ({
      ...prev,
      [id]: { ...(prev[id] || {}), preco: parseFloat(val) || 0 },
    }));

  // Calcula total do pedido
  const calcularTotalPedido = () => {
    return Object.entries(order).reduce((acc, [proId, data]) => {
      const prod = produtos.find((p) => p.proId === parseInt(proId));
      if (!prod) return acc;
      const preco = data.preco ?? (userInfo.tabelaPreco === "T" && tabelaSelecionada
      ? precosTabela[tabelaSelecionada]?.[prod.proId] ?? prod.proVlrVenda
      : prod.proVlrVenda);
      const qtd = data.quantidade ?? 0;
      return acc + preco * qtd;
    }, 0);
  };

  // Confirma pedido, valida e prepara dados para envio
  const confirmarPedido = () => {
    // Validação ANTES de qualquer processamento
    if (userInfo.bloqFinanceiro === 'T' && selectedCliente?.vencido === 'T') {
      alert('Cliente com pendências financeiras. Pedido bloqueado.');
      return;
    }

    if (!selectedCliente) {
      alert('Selecione um cliente!');
      return;
    }

    if (!paymentMethod || paymentMethod.trim() === "") {
      alert('Selecione uma forma de pagamento!');
      return;
    }

    if (userInfo.tabelaPreco === "T" && !tabelaSelecionada) {
      alert('Selecione uma tabela de preços!');
      return;
    }

    if (userInfo.obrigatotiodataentrega === "T" && (!dataEntrega || dataEntrega.trim() === "")) {
      alert('Data de entrega é obrigatória!');
      return;
    }

    const total = calcularTotalPedido();

    const formaVista = ['DINHEIRO', 'PIX', 'DEBITO', 'CREDITO'];

    // Se for edição, somamos o valor do pedido original ao limite disponível para validar a alteração
    const limiteDisponivelAjustado = pedidoSelecionado 
      ? (selectedCliente.limiteDisponivel ?? 0) + Number(pedidoSelecionado.nfeTotNota ?? 0)
      : (selectedCliente.limiteDisponivel ?? 0);

    if (
      userInfo.limiteCredito === 'T' &&
      !formaVista.includes(paymentMethod.toUpperCase()) &&
      total > limiteDisponivelAjustado
    ) {
      alert(
        `Limite de crédito excedido!\nLimite disponível ajustado: R$ ${limiteDisponivelAjustado.toFixed(
          2
        )}\nTotal do pedido: R$ ${total.toFixed(2)}`
      );
      return;
   }

   // Validar prazos antes de confirmar
  for (let i = 0; i < paymentTerms.length; i++) {
    const val = Number(paymentTerms[i]);  
    
    // 1° - Para BOLETO ou CARTEIRA, o primeiro campo deve ser maior que 0
    if ((paymentMethod === "BOLETO" || paymentMethod === "CARTEIRA") && i === 0 && val <= 0) {
      alert("Para BOLETO ou CARTEIRA, o primeiro prazo deve ser maior que 0 dias!");
      return;
    }
    
    // 2° - Se houver parcela anterior preenchida, a atual deve ser maior
    if (i > 0 && paymentTerms[i] !== '' && paymentTerms[i] != null) {
      const valorAnterior = Number(paymentTerms[i - 1]);
      if (paymentTerms[i - 1] !== '' && paymentTerms[i - 1] != null && val <= valorAnterior) {
        alert("O prazo da parcela deve ser maior que o anterior!");
        return;
      }
    }

    // 3° - Verifica se o VALOR do prazo é maior que o máximo permitido
    if (userInfo.limitarPrazoBoleto === 'T' && 
        (paymentMethod === "BOLETO" || paymentMethod === "CARTEIRA") &&
        val > Number(selectedCliente.prazoMaximo)) {
        
        console.log('ENTROU NA VALIDAÇÃO - VAI ALERTAR!');
        alert(`Prazo da parcela ${i + 1} (${val} dias) é MAIOR que o permitido no Cliente (${Number(selectedCliente.prazoMaximo)} dias)!`);
        return;
      }  
    }

    if (userInfo.descontoFinanceiro === "T" && descontoBoleto !== '' && userInfo.venFlexDisponivel < (descontoBoleto || 0)) {
      alert(`Desconto solicitado (${Number(descontoBoleto || 0).toFixed(2)}) é maior que o Flex disponível (${userInfo.venFlexDisponivel.toFixed(2)})!`);
      return;
    }

    if (produtos.length === 0) {
      alert('Nenhum produto adicionado.');
      return;
    }

    for (const [id, data] of Object.entries(order)) {
      if (data.quantidade > 0) {
        const produto = produtos.find(p => p.proId === parseInt(id));
        if (produto && data.preco <= 0) {
          alert(`Valor de venda do produto ${produto.proDescricao} deve ser maior que zero.`);
          return;
        }
      }
    }

    const totalGerado = Object.entries(order).reduce(
      (total, [proId, dados]) => {
        const produto = produtos.find(
          (p) => String(p.proId) === String(proId)
        );

        if (!produto) return total;

        const quantidade = Number(dados.quantidade) || 0;
        if (quantidade <= 0) return total;

        const precoBase =
          userInfo.tabelaPreco === "T" && tabelaSelecionada
            ? Number(
                precosTabela[tabelaSelecionada]?.[produto.proId] ??
                produto.proVlrVenda ??
                0
              )
            : Number(produto.proVlrVenda ?? 0);

        const precoPedido =
          dados.preco !== undefined && dados.preco !== null
            ? Number(dados.preco)
            : precoBase;

        return total + (precoPedido - precoBase) * quantidade;
      },
      0
    );

    const flexMaximo = Number(userInfo.flexMaximo) || 0;
    const totalFlex = (Number(totalGerado) || 0) + userInfo.venFlexDisponivel;

    if (userInfo.limitarFlex === "T" && totalFlex > flexMaximo) {
      alert(
        `Flex máximo permitido: ${flexMaximo.toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL",
        })}. Flex atual do pedido + Flex disponível: ${totalFlex.toLocaleString("pt-BR", {
          style: "currency",
          currency: "BRL",
        })}.`
      );
      return;
    }

    // Monta itens do pedido
    const ITEM_NFE = Object.entries(order)
      .map(([id, data]) => {
        const prod = produtos.find((p) => p.proId === parseInt(id));
        if (prod && data.quantidade > 0) {
          const item = {
            PRO_ID: prod.proId,
            descricao: prod.proDescricao,
            INFE_QTD_PRODUTO: data.quantidade,
            INFE_UNIDADE: data.embalagem || prod.embUnidade,
            INFE_VLR_PRODUTO: data.preco ??
                (
                  userInfo.tabelaPreco === "T" && tabelaSelecionada
                    ? precosTabela[tabelaSelecionada]?.[prod.proId] ?? prod.proVlrVenda
                    : prod.proVlrVenda
                ),
            INFE_VLR_LIQUIDO: data.preco ??
                (
                  userInfo.tabelaPreco === "T" && tabelaSelecionada
                    ? precosTabela[tabelaSelecionada]?.[prod.proId] ?? prod.proVlrVenda
                    : prod.proVlrVenda
                ),
            NCM_ID: prod.ncmId,
            INFE_ORDEM: data.ordem,
            INFE_VLR_VENDA: 
                (
                  userInfo.tabelaPreco === "T" && tabelaSelecionada
                    ? precosTabela[tabelaSelecionada]?.[prod.proId] ?? prod.proVlrVenda
                    : prod.proVlrVenda
                ),
            INFE_VLR_CUSTO: prod.proVlrCusto,
            INFE_VLR_COMPRA: prod.proVlrCompra,
            INFE_PER_COMISSAO: prod.proPerComissao,
            ordem: data.ordem,
            INFE_DESC_COMPLEMENTAR: data.descricaoComplementar || '',
          };
          return item;
        }
        return null;
      })
      .filter(Boolean)
      .sort((a, b) => (a.ordem || 999) - (b.ordem || 999)); // Trata undefined

    let prazos = paymentTerms.filter((p) => p && !isNaN(p));

    if (formaVista.includes(paymentMethod.toUpperCase()) && prazos.length === 0) {
      prazos = ['0'];
    }

    const totalVenda = ITEM_NFE.reduce(
      (acc, i) => acc + i.INFE_QTD_PRODUTO * i.INFE_VLR_PRODUTO,
      0
    );

    const valorParcela = Number((totalVenda / prazos.length).toFixed(2));
    const valorDescontoBoleto = Number((descontoBoleto  / prazos.length).toFixed(2));

    const RECEBER = prazos.map((dias) => {
      const dataVenc = new Date();
      dataVenc.setDate(dataVenc.getDate() + parseInt(dias, 10));

      return {
        CLI_ID: selectedCliente.cliId,
        VEN_ID: userInfo.ven_id,
        CRE_PAGAMENTO: paymentMethod,
        CRE_DTA_VENCIMENTO: dataVenc.toISOString().split('T')[0],
        CRE_VLR_RECEBER: valorParcela,
        CRE_STATUS: 'Em Aberto',
        CRE_VLR_DESCONTO: valorDescontoBoleto,
        CRE_TOT_DIFERENCA: Number((valorParcela - valorDescontoBoleto).toFixed(2)),
        CRE_OCULTAR: 'T',
      };
    });

    if (ITEM_NFE.length === 0) {
      alert('Nenhum produto adicionado.');
      return;
    }

    setOrderItems(ITEM_NFE);
    setReceber(RECEBER);
    setShowModal(true);
  };

  // Envia pedido ao servidor
  const enviarPedido = async () => {
    /*setIsSending(true);*/
    if (isSubmitting) return; // Evita múltiplos envios
  setIsSubmitting(true);
    const obsPedido = [
      NFE_OBS_PEDIDO, // sua observação original, se houver
      descontoBoleto && parseFloat(descontoBoleto) > 0
        ? `Desconto no boleto: R$ ${parseFloat(descontoBoleto).toFixed(2)}`
        : ''
    ]
    .filter(Boolean) // removes valores vazios
  .join(' | '); 

    const payload = {
      CLI_ID: selectedCliente.cliId,
      VEN_ID: userInfo.ven_id,
      NFE_DTA_CADASTRO: new Date().toISOString().split('T')[-3],
      NFE_DTA_ENTREGA:
        dataEntrega && dataEntrega.trim() !== ''
          ? dataEntrega
          : new Date().toISOString().split('T')[0],
      NFE_TOT_MERCADORIA: parseFloat(calcularTotalPedido()),
      NFE_TOT_NOTA: (calcularTotalPedido() - Number(desconto || 0) + Number(taxaEntrega || 0)).toFixed(2),
      NFE_TOT_DESCONTO: parseFloat(desconto) || 0,
      NFE_TOT_FRETE: parseFloat(taxaEntrega) || 0,
      NFE_OBS_PEDIDO: obsPedido + ` - Forma de pagamento: ${paymentMethod} - Prazos: ${paymentTerms.filter(p => p).join(', ')} dias`,
      NFE_TIPO_PEDIDO: 'VENDA',
      GEC_ID: 1,
      TAB_ID:  tabelaSelecionada || null,
      NFE_ORDEM_INTERNA: `WSAPP-${userInfo.ven_id}${Date.now()}`, // Gera um código único para a ordem interna
      ITEM_NFE: orderItems,
      RECEBER: receber,
    };

    try {
      const res = await fetch(`${userInfo.url}/nfe`,
        {
          method: 'POST',
          headers: {'Content-Type': 'application/json', empresa: userInfo.alias },
          body: JSON.stringify(payload),
        }
      );

    let data;
    try {
      data = await res.json();
    } catch (e) {
      data = null;
    }

    if (res.ok) {
      alert('Pedido enviado com sucesso!');
      await atualizarFlex();
      console.log("Payload a ser enviado:", JSON.stringify(payload, null, 2));
      
      if (userInfo.enviarEmailPedido === 'T') {
        console.log("Chamando enviarEmail com:", {
          ...payload,
          cliente_nome: selectedCliente.colFantasia || selectedCliente.colNome,
          vendedor_nome: userInfo.username,
          emailEnvioPedido: userInfo.emailEnvioPedido
        });
        await enviarEmail({
          ...payload,
          cliente_nome: selectedCliente.colFantasia || selectedCliente.colNome,
          vendedor_nome: userInfo.username,
          emailEnvioPedido: userInfo.emailEnvioPedido
        });
      }

      navigate('/menu');
    } else if (res.status === 426) {
      // Aqui tratamos produtos com estoque insuficiente
      const produtosComProblema = data?.map(p => `${p.PRO_DESCRICAO} (Saldo: ${p.SALDO_DISPONIVEL})`).join('\n') || "Erro de estoque";
      alert(`Não foi possível enviar o pedido. Estoque insuficiente nos produtos:\n${produtosComProblema}`);
    } else {
      alert('Erro ao enviar pedido.');
      console.log('Payload:', JSON.stringify(payload, null, 2));
      console.log('Resposta do servidor:', data);
    }
  } catch (err) {
    console.error('Erro ao enviar pedido:', err);
    alert('Falha na conexão com o servidor.');
  } finally {
    setIsSubmitting(false);
    }
  };

  //envio de email para o webhook
  const enviarEmail = async (payload) => {
    try {
      console.log("Vai tentar enviar e-mail para webhook:", payload);
      const emailPayload = {
        EMAIL: payload,
      };
      console.log("Tentando enviar e-mail para webhook:", emailPayload);

      const emailResponse = await fetch('https://backend.wensystem.com.br/webhook-test/envioEmailWenAPP',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(emailPayload),
        }
      );

      if (emailResponse.ok) {
        console.log('E-mail enviado com sucesso!');
      } else {
        console.error('Erro ao enviar e-mail:', emailResponse.status);
      }
    } catch (error) {
      console.error('Erro no envio do e-mail:', error);
    }
  };  

  //atualiza flex
  const atualizarFlex = async () => {
  const res = await fetch(`${userInfo.url}/login/v1`, {
    headers: {
      'Content-Type': 'application/json',
      'empresa': userInfo.alias,
      'Authorization': `Basic ${credentials}`,
    },
  });

  const novoUser = await res.json();
  setUserInfo(prev => ({
    ...prev,
    venFlexDisponivel: novoUser[0].venFlexDisponivel,
  }));
  };

  // Alterna expansão dos produtos no UI
  const toggleExpandProduto = (id) =>
    setExpandedProducts((prev) => ({ ...prev, [id]: !prev[id] }));

  // Filtra produtos para busca
  const safeSearch = (searchProduto || '').toLowerCase();
  const produtosFiltrados = produtos.filter(
    (p) =>
      (p.proDescricao?.toLowerCase().includes(safeSearch) || false) ||
      String(p.proCodInterno || '').includes(safeSearch) ||
      (p.marDescricao?.toLowerCase().includes(safeSearch) || false)
  );

const gerarPDF = () => {
  const modalContent = document.querySelector(".modal-content");

  // Salva estilos originais
  const originalMaxHeight = modalContent.style.maxHeight;
  const originalOverflow = modalContent.style.overflow;

  // Expande o conteúdo para capturar tudo
  modalContent.style.maxHeight = "none";
  modalContent.style.overflow = "visible";

  // Aguarda o layout atualizar
  setTimeout(() => {
    html2canvas(modalContent, {
      scale: 2,
      useCORS: true,
      allowTaint: false,
      ignoreElements: (el) => el.classList.contains("no-print"),
    }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const imgWidth = 210;
      const pageHeight = 297;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      let heightLeft = imgHeight;
      let position = 0;

      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      pdf.save("pedido.pdf");

      // Restaura estilos originais
      modalContent.style.maxHeight = originalMaxHeight;
      modalContent.style.overflow = originalOverflow;
    });
  }, 100); // pequeno delay para garantir que o layout foi atualizado
};


  const formatarData = (dataISO) => {
  if (!dataISO) return '';
  const [ano, mes, dia] = dataISO.split('-');
  return `${dia}/${mes}/${ano}`;
  }

  const formatarDataComHora = (dataISO) => {
    if (!dataISO) return '';
    const d = new Date(dataISO);
    return d.toLocaleDateString('pt-BR', { timeZone: 'UTC' });
  };

  const imprimirBoleto = async (creId, cliente) => {
      try {

        // 6️⃣ Depois dispara o fetch para gerar o boleto
        await fetch(`${userInfo.url}/receber/boleto/impressao/${creId}`, {
          method: "GET",
          headers: { empresa: userInfo.alias },
        });

        // 1️⃣ Gera a URL do PDF
        const pdfUrl = `${userInfo.url}/pdf/${userInfo.alias}/${selectedCliente.cliId}.pdf`;

        // 2️⃣ Fetch do PDF para download com nome personalizado
        const response = await fetch(pdfUrl);
        const blob = await response.blob();
        
        // 3️⃣ Cria URL do blob
        const url = window.URL.createObjectURL(blob);
        
        // 4️⃣ Download com nome personalizado
        const a = document.createElement('a');
        a.href = url;
        const agora = new Date();
        const dataHora = `${agora.getDate().toString().padStart(2, '0')}-${(agora.getMonth() + 1).toString().padStart(2, '0')}-${agora.getFullYear()}-${agora.getHours().toString().padStart(2, '0')}-${agora.getMinutes().toString().padStart(2, '0')}`;
        a.download = `Boleto-${cliente.colFantasia}-${dataHora}.pdf`;
        a.target = '_blank';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        
        // 5️⃣ Limpa a URL do blob
        window.URL.revokeObjectURL(url);
        
        
      } catch (err) {
        console.error(err);
        alert("Erro ao imprimir boleto");
      }
  };

  // Salvar orçamento
const limparCampos = () => {
  setSelectedCliente(null);
  setOrder({});
  setOrderItems([]);
  setDesconto('');
  setTaxaEntrega('');
  setPaymentMethod('');
  setPaymentTerms([]);
  setDataEntrega('');
  setNFE_OBS_PEDIDO('');
  setSearchTerm('');
  setDescontoBoleto('');
  setTabelaSelecionada('');
  setContadorOrdem(1); // 🎯 Resetar contador ao limpar
  setInfoComissaoProduto({}); // Limpa informações de comissão
};

  const salvarOrcamento = () => {
    const orcamento = {
      id: Date.now(),
      cliente: selectedCliente,
      order: order, // Adicione o objeto order também
      itens: orderItems,
      total: calcularTotalPedido(),
      desconto,
      taxaEntrega,
      paymentMethod,
      paymentTerms,
      dataEntrega,
      observacoes: NFE_OBS_PEDIDO,
      dataCriacao: new Date().toISOString()
    };

    const orcamentos = JSON.parse(localStorage.getItem('orcamentos')) || [];
    orcamentos.push(orcamento);
    localStorage.setItem('orcamentos', JSON.stringify(orcamentos));
    
    alert('Orçamento salvo!');
    limparCampos(); // Limpa após salvar
  };

  // Carregar orçamentos
  const carregarOrcamentos = () => {
    return JSON.parse(localStorage.getItem('orcamentos')) || [];
  };

  // Carregar orçamento específico
  const carregarOrcamento = (id) => {
    const orcamentos = carregarOrcamentos();
    const orcamento = orcamentos.find(o => o.id === id);
    
    if (orcamento) {
      setSelectedCliente(orcamento.cliente);
      setOrder(orcamento.order || {}); // Carrega os produtos com quantidades
      setOrderItems(orcamento.itens);
      setDesconto(orcamento.desconto || '');
      setTaxaEntrega(orcamento.taxaEntrega || '');
      setPaymentMethod(orcamento.paymentMethod || '');
      setPaymentTerms(orcamento.paymentTerms || []);
      setDataEntrega(orcamento.dataEntrega || '');
      setNFE_OBS_PEDIDO(orcamento.observacoes || '');
      setSearchTerm(orcamento.cliente?.colNome || '');
      
      alert('Orçamento carregado!');
    }
  };

  const excluirOrcamento = (id) => {
    let orcamentos = carregarOrcamentos();
    orcamentos = orcamentos.filter(o => o.id !== id);
    localStorage.setItem('orcamentos', JSON.stringify(orcamentos));
    
    // Atualiza o estado para refletir na tela
    setOrcamentosSalvos(orcamentos);
    
    alert('Orçamento excluído!');
  };

  // edição de pedido existente
  const handleEditarPedido = async () => {
    setIsSubmitting(true);
    try {
      let res = null;
      let data = null;
      let requestBody = null;

      if (itensRemovidos.length > 0 || itensEditados.length > 0) {
        // Deleta itens removidos
        for (const infeId of itensRemovidos) {
          await fetch(`${userInfo.url}/itemnfe/${infeId}`, {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
              'empresa': userInfo.alias,
              'Authorization': `Basic ${credentials}`,
              'venId': userInfo.ven_id,
            }
          });
        }

        // Posta itens novos/alterados

  {
  // Monta o requestBody normalmente
  let requestBody = {
    CLI_ID: pedidoSelecionado.cliId,
    VEN_ID: pedidoSelecionado.venId,
    NFE_ID: pedidoSelecionado.nfeId,
    NFE_OBS_PEDIDO: NFE_OBS_PEDIDO,
    NFE_DTA_ENTREGA: dataEntrega,
    ITEM_NFE: itensEditados.length > 0
      ? itensEditados.map(item => ({
          PRO_ID: item.proId,
          descricao: item.proDescricao,
          INFE_QTD_PRODUTO: item.infeQtdProduto,
          INFE_UNIDADE: item.infeUnidade,
          INFE_VLR_PRODUTO: item.infeVlrProduto,
          INFE_VLR_LIQUIDO: item.infeVlrProduto,
          NCM_ID: item.ncmId,
          ordem: item.infeOrdem,
          INFE_VLR_VENDA: item.proVlrVenda,
          INFE_VLR_CUSTO: item.proVlrCusto,
          INFE_VLR_COMPRA: item.proVlrCompra,
          INFE_PER_COMISSAO: item.proPerComissao,
        }))
      : [], // Sempre envia o array, mesmo vazio
  };

          res = await fetch(`${userInfo.url}/itemnfe`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'empresa': userInfo.alias,
              'Authorization': `Basic ${credentials}`,
              'venId': userInfo.ven_id,
            },
            body: JSON.stringify(requestBody)
          });

          const contentType = res.headers.get("content-type");
          data = contentType && contentType.includes("application/json") ? await res.json() : await res.text();

          if (res.ok) {
           // console.log('Itens editados enviados com sucesso:', requestBody);
          } else {
            //console.error('Erro ao enviar itens editados:', data);
            alert(`Erro ao enviar itens editados.
              ${data}`);
            //console.log('Payload enviado:', JSON.stringify(requestBody));
            //console.log('Resposta do servidor:', data);
            return; // Interrompe o processo se falhou ao enviar itens editados
          }
        }

        // Só faz o tratamento se houve POST
        if (!res || res.ok) {
          alert('Pedido editado com sucesso!');

          if (userInfo.enviarEmailPedido === 'T') {
            await enviarEmail({
              ...requestBody,
              cliente_nome: selectedCliente?.colFantasia || selectedCliente?.colNome,
              vendedor_nome: userInfo.username,
              emailEnvioPedido: userInfo.emailEnvioPedido 
            });
          }

          atualizarFlex();
          setItensEditados([]);
          setItensRemovidos([]);
          navigate('/menu');
        } else if (res.status === 426) {
          const produtosComProblema = Array.isArray(data) ? data.map(p => `${p.PRO_DESCRICAO} (Saldo: ${p.SALDO_DISPONIVEL})`).join('\n') : "Erro de estoque";
          alert(`Não foi possível editar o pedido. Estoque insuficiente nos produtos:\n${produtosComProblema}`);
        } else {
          alert('Erro ao editar pedido.');
          //console.log('Payload:', JSON.stringify(requestBody));
          //console.log('Resposta do servidor:', data);
        }
      } else {
        alert('Nenhuma alteração para salvar.');
        //console.log('Nenhuma alteração detectada. Nfe: ', requestBody, data, 'Itens editados:', itensEditados, 'Itens removidos:', itensRemovidos);
      }
    } catch (err) {
      console.error('Erro ao editar pedido:', err);
      alert('Falha na conexão com o servidor.');
    } finally {
      setIsSubmitting(false);
    }
  };

  // Atualiza automaticamente a comissão de cada produto (qtd × preço × %comissão)
  useEffect(() => {
    const novasComissoes = {};

    Object.entries(order).forEach(([proIdStr, dados]) => {
      const qtd = Number(dados.quantidade) || 0;
      if (qtd <= 0) return;

      const prod = produtos.find((p) => p.proId === parseInt(proIdStr, 10));
      if (!prod) return;

      const preco =
        dados.preco ??
        (userInfo.tabelaPreco === "T" && tabelaSelecionada
          ? precosTabela[tabelaSelecionada]?.[prod.proId] ?? prod.proVlrVenda
          : prod.proVlrVenda);

      const percentual = Number(prod.proPerComissao || 0);
      const valorComissao = qtd * (Number(preco) || 0) * (percentual / 100);

      novasComissoes[prod.proId] =
        `✅ Comissão (${percentual.toLocaleString("pt-BR")}%): ${valorComissao.toLocaleString(
          "pt-BR",
          { style: "currency", currency: "BRL" }
        )}`;
    });

    setInfoComissaoProduto(novasComissoes);
  }, [order, produtos, userInfo, tabelaSelecionada, precosTabela]);

  return (
    <>
    {loadingPedidos ? (
      <div className="loading-container" tabIndex={-1}>
        <img src={logo} alt="Logo" className="loading-logo" />
        <p>Carregando dados, aguarde...</p>
      </div>
    ) : (
    <>
      <header className="header">
        <img src={`${userInfo.url}/imagens/${userInfo.alias}.bmp`} alt="Logo da empresa"  className='logoHeader'></img>
        <h2>Bem-vindo, {userInfo.username}!</h2>
        {userInfo.controlaFlex === 'T' && (
            <span className={(userInfo.venFlexDisponivel ?? 0) < 0 ? 'flex-negativo' : 'flex-positivo'}>
              <strong>Seu flex atual é de : {(userInfo.venFlexDisponivel ?? 0 ).toLocaleString("pt-BR", {style: "currency", currency: "BRL",})}</strong></span>)}
        {userInfo.descontoFinanceiro === 'T' && (
            <span className={(userInfo.venFlexDisponivel ?? 0) < 0 ? 'flex-negativo' : 'flex-positivo'}>
              <strong>Seu flex atual é de : {(userInfo.venFlexDisponivel ?? 0 ).toLocaleString("pt-BR", {style: "currency", currency: "BRL",})}</strong></span>)}
        <h1>Pedido de Venda {userInfo.company}</h1>
      </header>

      <div className='top-bar'>
        <Link to="/menu" className="link-style">Voltar ao menu</Link>
        <button className="btnOrcamentos" onClick={() => {
          setOrcamentosSalvos(carregarOrcamentos());
          setShowOrcamentos(true);
        }}>Orçamentos Salvos</button>
      </div>

        <div className="containerOrcamento">
          {/* Listar orçamentos salvos*/}
          {showOrcamentos && (
            <div className="modal-orcamentos">
              <h3>Orçamentos Salvos</h3>
              {orcamentosSalvos.map(orc => (
                <div key={orc.id} className="orcamento-item">
                  <span>{orc.cliente.colNome} - R$ {orc.total.toFixed(2)}</span>
                  <button className='btnCarregar' onClick={() => carregarOrcamento(orc.id)}>Carregar</button>
                  <button className='btnExcluir' onClick={() => excluirOrcamento(orc.id)}>Excluir</button>
                </div> 
              ))}
              <div>
                <button className='fecharOrcamentos' onClick={() => setShowOrcamentos(false)}>Fechar</button>
              </div>
            </div>
          )}
        </div>

        {userInfo.editarPedido === 'T' && (
          <button className='btnListar' onClick={() => {
            listarPedidos();
            setShowPedidosEdicao(true);
          }}>
            Listar Pedidos Para Edição
          </button>
        )}
        
        {pedidoSelecionado && (
          <div className="pedidoSelecionadoInfo">
            <h3>Atenção ao selecionar um pedido para edição, não é possivel alterar o cliente, pagamento, data de entrada e observações.</h3>
          </div>
        )}

        {showPedidosEdicao && (
          <div className="containerEditar">
            {loadingPedidos && <p>Carregando pedidos...</p>}
            <ul className='listaPedidos'>
              {pedidos.map(p => (
                <li className='pedidoItem' key={p.nfeId}>
                  <span>{p.colFantasia} - R$ {p.nfeTotNota}</span>
                  <button className='btnEditar' onClick={() => {
                    selecionarPedido(p.nfeId);
                    setShowPedidosEdicao(false); // Fecha a janela ao selecionar
                  }}>
                    Editar
                  </button>
                </li>
              ))}
            </ul>
            <button onClick={() => setShowPedidosEdicao(false)}>Fechar</button>
          </div>
        )}

      {/* 🔹 Pesquisa de Cliente */}
      <div className="cliente-box">
      <input
        type="text"
        placeholder="Pesquisar cliente..."
        value={selectedCliente ? selectedCliente.colFantasia : searchTerm}
        disabled={pedidoSelecionado}
        onChange={(e) => {
          setSearchTerm(e.target.value);
          setSelectedCliente(null);
          setShowSuggestions(true);
        }}
        onFocus={() => setShowSuggestions(true)}
      />
        {searchTerm && (
          <button
            className="clear-button"
            title="Limpar pesquisa"
            onClick={() => {
              setSearchTerm('');
              setShowSuggestions(false); // ou true, se quiser manter a lista aberta
            }}
          >
            ❌
          </button>
        )}

        {/* 🔹 Lista de sugestões (só aparece se showSuggestions for true) */}
        {showSuggestions && searchTerm && (
          <ul className="cliente-list"
          disabled={pedidoSelecionado}>
            {filteredClientes.length > 0 ? (
              filteredClientes.map((c, index) => (
                <li key={`${c.cliId}-${index}`} value={c.cliId} onClick={() => handleSelectCliente(c)}
                disabled={pedidoSelecionado}>
                  {c.cliId} - <strong>{c.colNome}</strong> <br /> {c.colFantasia}
                </li>
              ))
            ) : (
              <li>❌ Nenhum cliente encontrado</li>
            )}
          </ul>
        )}
      </div>

      {/* 🔹 Informações do Cliente */}
      {selectedCliente?.vencido === 'T' && (
        <form className="financeiroAtrasado">
          <h3>CLIENTE COM PENDÊNCIAS FINANCEIRAS!</h3>
        </form>
      )}
      {selectedCliente && (
        <div className="cliente-info-principal">
            <span><strong>Razão:</strong> {selectedCliente.colNome}</span>
            <span><strong>Limite de Crédito:</strong> {
            (selectedCliente.cliLimiteCredito ?? 0).toLocaleString("pt-BR", {style: "currency", currency: "BRL",})
            }</span>
            <span><strong>Limite disponível:</strong> {
              (pedidoSelecionado 
                ? (selectedCliente.limiteDisponivel ?? 0) + Number(pedidoSelecionado.nfeTotNota ?? 0)
                : (selectedCliente.limiteDisponivel ?? 0)
              ).toLocaleString("pt-BR", {style: "currency", currency: "BRL",})
            }</span>            
        </div>
      )}
      <div className="btnCarrinhoContainer">
          {/* 🔹 Informações do Cliente */}
          {selectedCliente && (
            <div className="cliente-info">
              <button className='btnExpandir' onClick={() => setShowClienteInfo((prev) => !prev)}>
                {showClienteInfo ? '− Ocultar' : '+ Mostrar'} informações do cliente
              </button>
              {showClienteInfo && (
                <div className="cliente-detalhes">  
                    <span><strong>CNPJ/CPF:</strong> {selectedCliente.colCnpjCpf}</span>
                    <span><strong>Inscrição Estadual:</strong> {selectedCliente.colInscricaoEstadual}</span>
                    <span><strong>Endereço:</strong> {selectedCliente.endRua}, {selectedCliente.endNumero}</span>
                    <span><strong>Complemento:</strong> {selectedCliente.endComplemento}</span>
                    <span><strong>Cidade:</strong> {selectedCliente.endCidade}</span>
                    <span><strong>UF:</strong> {selectedCliente.endEstado}</span>
                    <span><strong>CEP:</strong> {selectedCliente.endCep}</span>
                    <span><strong>Email:</strong> {selectedCliente.colEmail}</span>
                    <span><strong>Contato:</strong> {selectedCliente.colContato}</span>
                    <span><strong>Fone1:</strong> {selectedCliente.colFone1}</span>
                    <span><strong>Fone2:</strong> {selectedCliente.colFone2}</span>
                    <span ><strong>Whats:</strong> {selectedCliente.colCelularWhatsapp} </span>
                    <span><strong>Forma de Pagamento:</strong> {selectedCliente.pagDescricao}</span>
                    <span><strong>Prazo de Pagamento:</strong> {selectedCliente.prazo}</span>
                    <span><strong>Limite de Crédito:</strong> R$ {selectedCliente.cliLimiteCredito.toFixed(2)}<strong> - Limite Disponível: R$ {(selectedCliente.limiteDisponivel).toFixed(2)}</strong></span>
                {financeiroAtrasado.length > 0 && (
                  <div className="financeiro-lista">
                    <h4>Financeiro em Aberto</h4>
                    <table>
                      <thead>
                        <tr>
                          <th>Vencimento</th>
                          <th>Pedido</th>
                          <th>Valor</th>
                          <th>Título/Parcela</th>
                          <th>🖨️ Boleto</th>
                        </tr>
                      </thead>
                      <tbody>
                        {financeiroAtrasado.map((item, i) => (
                          <tr key={i}>
                            <td>{formatarDataComHora(item.creDtaVencimento)}</td>
                            <td>{item.nfePedido}</td>
                            <td>{item.creVlrReceber}</td>
                            <td>{item.creTitulo}-{item.creParcela}</td>
                            <td>{item.crePagamento === 'BOLETO' && (<button className='impBoleto' onClick={() => imprimirBoleto(item.creId, selectedCliente)}>🧾</button>)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
                </div>
              )}
            </div>
            )}        
          <button className='btnCarrinho' onClick={confirmarPedido}>🛒 {(calcularTotalPedido() ?? 0).toLocaleString("pt-BR", {style: "currency", currency: "BRL",})}</button>  
        </div>

      {/* 🔹 Quadro de Pagamento */}
      {selectedCliente && (
        <div className="payment-box">
          <h3>💳 Condições de Pagamento</h3>

          {/* 🔹 Seletor de forma de pagamento */}
          <select value={paymentMethod} onChange={(e) => setPaymentMethod(e.target.value.toUpperCase())}>
            <option value="">Selecione...</option>
            <option value="DINHEIRO">Dinheiro</option>
            <option value="DEBITO">Débito</option>
            <option value="CREDITO">Crédito</option>
            <option value="BOLETO">Boleto</option>
            <option value="PIX">Pix</option>
            <option value="CARTEIRA">Carteira</option>
          </select>

          {/* 🔹 Campos de prazos */}
          <div className="terms-container">
            {paymentTerms.map((term, idx) => (
              <input
                key={idx}
                type="number"
                min={1}
                disabled={paymentMethod === "DINHEIRO" || paymentMethod === "PIX" || paymentMethod === "DEBITO" || paymentMethod === "CREDITO"}
                placeholder={`${7 * (idx + 1)} dias`}
                value={term}
                onChange={(e) => handleTermChange(idx, e.target.value)}
                onBlur={(e) => handleTermBlur(idx, e.target.value)}
              />
            ))}
          </div>
        </div>
      )}

      {/* 🔹 Filtro de produtos */}
      <div>
        <input
          type="text"
          className='pesqProdVenda'
          placeholder="Filtrar produtos por nome ou código..."
          value={searchProduto}
          onChange={(e) => setSearchProduto(e.target.value)}
        />
        <Checkbox className="produto sem estoque" label="Em Estoque" onClick={() => setEstoqueProdutos((prev) => !prev)} />
        <label className="checkbox-label">Exibir apenas produtos com estoque</label>
        <Checkbox className="produto sem estoque" label="Itens do Pedido" onClick={() => setJaIncluido((prev) => !prev)} />
        <label className="checkbox-label">Exibir apenas itens do pedido</label>
      </div>
      {/* No JSX - Botões para trocar aba*/}
      <div className="tabs">
        <button onClick={() => setAbaSelecionada("Produtos")}>Produtos</button>
        <button disabled={!selectedCliente} onClick={() => setAbaSelecionada("Mix")}>Mix</button>
      {/* select de tabelas */}
      {userInfo.tabelaPreco === "T" && (
          <select
            value={tabelaSelecionada || ""}
            onChange={(e) => setTabelaSelecionada(Number(e.target.value))}
          >
            
            {tabelas
            .filter(
              (t) => String(t.tabId) === String(selectedCliente?.tabId)
            )
            .map((t) => (
              <option key={t.tabId} value={t.tabId}>
                {t.tabDescricao}
              </option>
            ))}
            <option value="">Selecione</option>
          </select>
          
      )}
      </div>
  {userInfo.bloqFinanceiro === "T" && !selectedCliente
    ? <p>Selecione um cliente para visualizar os produtos.</p>
  : (    
  <div>
      {/*Renderização condicional*/}
      {abaSelecionada === "Produtos" && (
      <div className="container">
        {produtosFiltrados
        .filter(p => estoqueProdutos || p.proQtdEstoque > 0,1)
        .filter(p => jaIncluido ? order[p.proId]?.quantidade > 0 : true)
        .map((p) => {
          const infoComissao = infoComissaoProduto[p.proId] || "";
          const dados = order[p.proId] || {};
          // 🔹 Coloque aqui o cálculo do preço do item
          const precoItem = dados.preco ?? (
            userInfo.tabelaPreco === "T" && tabelaSelecionada
              ? precosTabela[tabelaSelecionada]?.[p.proId] ?? p.proVlrVenda
              : p.proVlrVenda
          );          
          return (
            <div key={p.proId} className="product-item">
              <div className={`cabProd ${p.proQtdEstoque < 0.01 && userInfo.controlaEstoque === 'T' ? 'estoque-baixo' : ''}`}>
               <span className="linha-superior"><strong>{p.proCodInterno} - {p.proDescricao}</strong></span>
                {userInfo.tabelaPreco === "F" && (<span>💰 {(p.proVlrVenda ?? 0).toLocaleString("pt-BR", {style: "currency", currency: "BRL",})}</span>)}
                <span>
                  📦 Est:{" "}
                  {p.proQtdEstoque != null
                    ? p.proQtdEstoque.toLocaleString("pt-BR", {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 3,
                      })
                    : "0,000"}{" "}
                  {p.embUnidade}
                </span>
                <span><strong>Marca:</strong> {p.marDescricao}</span>
                <button className='btnInfProd' onClick={() => toggleExpandProduto(p.proId)}>
                  {expandedProducts[p.proId] ? '−' : '+'}
                </button>
                </div>
            <div className="quantity-controls">
              <label>Qtd:</label>
                  <NumericInput
                    value={dados.quantidade}
                    decimals={3}
                disabled={selectedCliente?.vencido === "T" && userInfo?.bloqFinanceiro === "T"}
                    onChangeRaw={(raw) => handleQuantityChange(p.proId, raw)}
                    onBlurNumber={(num) => {
                      setOrder((prev) => ({
                        ...prev,
                        [p.proId]: {
                          ...prev[p.proId],
                          quantidade: num,
                        },
                      }));
                    }}
                  />

                  {userInfo.alterarEmbalagem === "T" && (
                      <select
                        value={dados.embalagem || p.embUnidade}
                        onChange={(e) => {
                          setOrder((prev) => ({
                            ...prev,
                            [p.proId]: {
                              ...prev[p.proId],
                              embalagem: e.target.value,
                            },
                          }));
                        }}
                      >
                        <option value={p.embUnidade}>{p.embUnidade}</option>
                        <option value="KG">KG</option>
                        <option value="UN">UN</option>
                        <option value="CX">CX</option>
                        <option value="LT">LT</option>
                        <option value="PCT">PCT</option>
                        <option value="FD">FD</option>
                      </select>
                  )}
                      
                <label>Preço:</label>
                  <NumericInput
                    value={dados.preco ??
                      (
                        userInfo.tabelaPreco === "T" && tabelaSelecionada
                          ? precosTabela[tabelaSelecionada]?.[p.proId] ?? p.proVlrVenda
                          : p.proVlrVenda
                      )
                    }
                    decimals={2}
                    disabled={userInfo.alterarPreco === "F"}
                  onChangeRaw={raw => {
                    const preco = parseFloat(raw);
                    const precoFormatado = isNaN(preco) ? 0 : parseFloat(preco.toFixed(2));
                    setOrder(prev => ({
                      ...prev,
                      [p.proId]: {
                        ...prev[p.proId],
                        preco: precoFormatado,
                      }
                    }));

                    if (pedidoSelecionado) {
                      const prod = produtos.find(produto => produto.proId === p.proId);
                      const quantidade = order[p.proId]?.quantidade ?? 1;

                      // Adiciona o infeId do item original para remoção, se existir
                      const itemOriginal = itensPedido.find(item => item.proId === p.proId);
                      if (itemOriginal && itemOriginal.infeId) {
                        setItensRemovidos(prev => {
                          // Evita duplicidade
                          if (!prev.includes(itemOriginal.infeId)) {
                            return [...prev, itemOriginal.infeId];
                          }
                          return prev;
                        });
                      }

                      setItensEditados(prev => {
                        const jaExiste = prev.some(item => item.proId === p.proId);
                        const novoItem = {
                          proId: prod.proId,
                          proDescricao: prod.proDescricao,
                          infeQtdProduto: quantidade,
                          infeUnidade: order[p.proId]?.embalagem || prod.embUnidade,
                          infeVlrProduto: precoFormatado,
                          infeVlrLiquido: precoFormatado,
                          ncmId: prod.ncmId,
                          infeOrdem: order[p.proId]?.ordem,
                          proVlrCompra: prod.proVlrCompra,
                          proVlrCusto: prod.proVlrCusto,
                          proVlrVenda: prod.proVlrVenda,
                          proPerComissao: prod.proPerComissao,
                        };
                        if (jaExiste) {
                          return prev.map(item => item.proId === p.proId ? novoItem : item);
                        } else {
                          return [...prev, novoItem];
                        }
                      });
                    }
                  }}
                  />

                <label>Total:</label>
                <input
                  type="number"
                  step="0.01"
                  value={(precoItem * (dados.quantidade || 0)).toFixed(2)}
                  onChange={(e) => handlePriceChange(p.proId, e.target.value)}
                  disabled
                />

                {userInfo.complementoPedido === "T" && (
                  <div>
                    <label>Complem.</label>
                    <input 
                      className='descricaoComplementar'
                      type='text'
                      onChange={(e) => {
                        const valor = e.target.value;
                        setOrder(prev => ({
                          ...prev,
                          [p.proId]: {
                            ...prev[p.proId],
                            descricaoComplementar: valor
                          }
                        }));
                      }}
                    />
                  </div>
                )}

                {userInfo.tabelaIndividual=== "T" && (
                    <select
                      className="tabelaIndividual"
                      value={tabelaSelecionada || ""}
                      onChange={(e) => setTabelaSelecionada(Number(e.target.value))}
                    >
                      <option value="">Selecione uma Tabela de Preços</option>
                      {tabelas.map((t) => (
                        <option key={t.tabId} value={t.tabId}>
                          {t.tabDescricao}
                        </option>
                      ))}
                    </select>
                )}

              </div>

              {expandedProducts[p.proId] && (
                <div className="produto-detalhes no">
                  <p className="qtdComprado"><b>Comprado:</b> {p.qtdComprado}</p>
                  <p className="valorUnitario"><b>Valor Unitário:</b> {p.proVlrBalcao}</p>
                  <p><b>Unidade:</b> {p.embUnidade}</p>
                  <p><b>Referência:</b> {p.proReferencia || '-'}</p>
                  <p><b>Grupo:</b> {p.gruDescricao || '-'}</p>
                  <p><b>SubGrupo:</b> {p.subDescricao || '-'}</p>
                  <p><b>% de comissao:</b> {p.proPerComissao || '-'} %</p>
                </div>
              )}

              <div>
                {infoComissao && (
                  <div className={`validacao-preco ${infoComissao.includes('✅') ? 'valido' : 'invalido'}`}>
                    {infoComissao}
                  </div>
                )}
              </div>

            </div>
          );
        })}
      </div>
        )}

        {abaSelecionada === "Mix" && (
          loadingPedidos ? (
            <p className='loadingMix'>Carregando dados, aguarde...</p>
          ) : mixProdutos.length > 0 ? (
            <div className='container'>
              {mixProdutos.map((p, index) => {
                const dados = order[p.proId] || {};
                const precoItem = dados.preco ??
                  (
                    userInfo.tabelaPreco === "T" && tabelaSelecionada
                      ? precosTabela[tabelaSelecionada]?.[p.proId] ?? p.proVlrVenda
                      : p.proVlrVenda
                  );
                return (
                  <div key={p.proId} className="product-item"> 
                    <div className={`cabProd2 ${p.proQtdEstoque < 0.01 && userInfo.controlaEstoque === 'T' ? 'estoque-baixo' : ''}`}>
                      <span><strong>{p.proCodInterno} - {p.proDescricao}</strong></span>
                      {userInfo.tabelaPreco === "F" && (<span>💰 {(p.proVlrVenda ?? 0).toLocaleString("pt-BR", {style: "currency", currency: "BRL",})}</span>)}
                      <span>
                        📦 Est:{" "}
                        {p.proQtdEstoque != null
                          ? p.proQtdEstoque.toLocaleString("pt-BR", {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 3,
                          })
                          : "0,000"}{" "}
                        {p.embUnidade}
                      </span>
                      <span><strong>Marca:</strong> {p.marDescricao}</span>
                      <button className='btnInfProd' onClick={() => toggleExpandProduto(p.proId)}>{expandedProducts[p.proId] ? '−' : '+'}</button>
                    </div>
                    <div className="quantity-controls-mix">
                      
                      <label>Qtd:</label>
                      {/* Quantidade */}
                      <NumericInput
                        value={dados.quantidade ?? ""}
                        decimals={3} // até 3 casas decimais
                        disabled={selectedCliente?.vencido === "T" && userInfo?.bloqFinanceiro === "T"}
                        onChangeRaw={(raw) => handleQuantityChange(p.proId, raw)}
                        onBlurNumber={(num) => {
                          // aplica min/max manualmente
                          const quantidade = Math.min(
                            userInfo.controlaEstoque === "T" ? p.proQtdEstoque : Infinity,
                            Math.max(0, num) // não deixa menor que 0
                          );

                          setOrder((prev) => ({
                            ...prev,
                            [p.proId]: {
                              ...prev[p.proId],
                              quantidade: parseFloat(quantidade.toFixed(3)),
                            },
                          }));
                        }}
                      />

                      {userInfo.alterarEmbalagem === "T" && (
                          <select
                            value={dados.embalagem || p.embUnidade}
                            onChange={(e) => {
                              setOrder((prev) => ({
                                ...prev,
                                [p.proId]: {
                                  ...prev[p.proId],
                                  embalagem: e.target.value,
                                },
                              }));
                            }}
                          >
                            <option value={p.embUnidade}>{p.embUnidade}</option>
                            <option value="KG">KG</option>
                            <option value="UN">UN</option>
                            <option value="CX">CX</option>
                            <option value="LT">LT</option>
                            <option value="PCT">PCT</option>
                            <option value="FD">FD</option>
                          </select>
                      )}

                      <label>Preço:</label>
                      <NumericInput
                        value={
                          dados.preco ??
                          (
                            userInfo.tabelaPreco === "T" && tabelaSelecionada
                              ? precosTabela[tabelaSelecionada]?.[p.proId] ?? p.proVlrVenda
                              : p.proVlrVenda
                          )
                        }
                        decimals={2} // duas casas para valores monetários
                        disabled={userInfo.alterarPreco === "F"}
                        onChangeRaw={raw => {
                          const preco = parseFloat(raw);
                          const precoFormatado = isNaN(preco) ? 0 : parseFloat(preco.toFixed(2));
                          setOrder(prev => ({
                            ...prev,
                            [p.proId]: {
                              ...prev[p.proId],
                              preco: precoFormatado,
                            }
                          }));

                          if (pedidoSelecionado) {
                            const prod = produtos.find(produto => produto.proId === p.proId);
                            const quantidade = order[p.proId]?.quantidade ?? 1;

                            // Adiciona o infeId do item original para remoção, se existir
                            const itemOriginal = itensPedido.find(item => item.proId === p.proId);
                            if (itemOriginal && itemOriginal.infeId) {
                              setItensRemovidos(prev => {
                                // Evita duplicidade
                                if (!prev.includes(itemOriginal.infeId)) {
                                  return [...prev, itemOriginal.infeId];
                                }
                                return prev;
                              });
                            }

                            setItensEditados(prev => {
                              const jaExiste = prev.some(item => item.proId === p.proId);
                              const novoItem = {
                                proId: prod.proId,
                                proDescricao: prod.proDescricao,
                                infeQtdProduto: quantidade,
                                infeUnidade: order[p.proId]?.embalagem || prod.embUnidade,
                                infeVlrProduto: precoFormatado,
                                infeVlrLiquido: precoFormatado,
                                ncmId: prod.ncmId,
                                infeOrdem: order[p.proId]?.ordem,
                                proVlrCompra: prod.proVlrCompra,
                                proVlrCusto: prod.proVlrCusto,
                                proVlrVenda: prod.proVlrVenda,
                                proPerComissao: prod.proPerComissao,
                              };
                              if (jaExiste) {
                                return prev.map(item => item.proId === p.proId ? novoItem : item);
                              } else {
                                return [...prev, novoItem];
                              }
                            });
                          }
                        }}
                      />

                      <label>Total:</label>
                      <input
                        type="number"
                        step="0.01"
                        value={(precoItem * (dados.quantidade || 0)).toFixed(2)}
                        onChange={(e) => handlePriceChange(p.proId, e.target.value)}
                        disabled
                      />
                      
                      {userInfo.complementoPedido === "T" && (
                        <div>
                          <label>Complem.</label>
                          <input 
                            className='descricaoComplementar'
                            type='text'
                            onChange={(e) => {
                              const valor = e.target.value;
                              setOrder(prev => ({
                                ...prev,
                                [p.proId]: {
                                  ...prev[p.proId],
                                  descricaoComplementar: valor
                                }
                              }));
                            }}
                          />
                        </div>
                      )}

                    <div className='dadosMix'>
                    <span>Último valor: 💰 {(p.vlrUltVenda ?? 0).toLocaleString("pt-BR", {style: "currency", currency: "BRL",})}</span>
                    <span>📦 Qtd última compra: {p.qtdPeriodo}</span>
                    </div>
                    </div>
                    {expandedProducts[p.proId] && (
                    <div className="produto-detalhes no">
                      <p className="qtdComprado"><b>Comprado:</b> {p.qtdComprado}</p>
                      <p className="valorUnitario"><b>Valor Unitário:</b> {p.proVlrBalcao}</p>
                      <p><b>Unidade:</b> {p.embUnidade}</p>
                      <p><b>Referência:</b> {p.proReferencia || '-'}</p>
                      <p><b>Grupo:</b> {p.gruDescricao || '-'}</p>
                      <p><b>SubGrupo:</b> {p.subDescricao || '-'}</p>
                    </div>
                  )}
                  </div>
                );
              })}
            </div>
          ) : !loadingPedidos ? (
            <p className='loadingMix'>❌ Nenhum Produto do Mix encontrado!</p>
          ) : null
        )}
  </div>)}

      {/* 🔹 Informações adicionais do pedido */}
      <div className='infoAdicionalPedido'>
        <div className='infoaddSuperiror'>
          <label>Data de entrega:</label>
            <input
              className='dtaEntrega'
              type='date'
              required={userInfo.obrigatotiodataentrega === "T"}
              value={dataEntrega}
              disabled={pedidoSelecionado}
              onChange={(e) => setDataEntrega(e.target.value)}
            />
            {userInfo.descontoPedido === "T" && (<input
              className='descontoPedido'
              placeholder='R$ Desconto Pedido'
              type='text'
              value={desconto || ''}
              onChange={(e) => setDesconto(e.target.value)}
            />)}
            {userInfo.descontoFinanceiro === "T" && (<input
              className='descontoPedido'
              placeholder='R$ Desconto Boleto'
              type='text'
              value={descontoBoleto || ''}
              disabled={pedidoSelecionado}
              onChange={(e) => setDescontoBoleto(e.target.value)}
            />)}
            {userInfo.taxaEntrega === "T" && (<input
              className='descontoPedido'
              placeholder='R$ Taxa de Entrega'
              type='text'
              value={taxaEntrega || ''}
              onChange={(e) => setTaxaEntrega(e.target.value)}
            />)}

        </div>
        <label>Observação:</label>
          <textarea
            className='obsPedido'
            value={NFE_OBS_PEDIDO}
            onChange={(e) => setNFE_OBS_PEDIDO(e.target.value)}
            disabled={pedidoSelecionado}
          />
      </div>

      <div className="btnCarrinhoContainer"> 
        <button className='btnCarrinho' onClick={confirmarPedido}>🛒 Conferir Carrinho</button>
      </div>

      {/* 🔹 Modal de conferência */}
      {showModal && (
        <div className="modal">
          <div className="modal-content">
          <img src={`${userInfo.url}/imagens/${userInfo.alias}.bmp`} alt="Logo da empresa" ></img>
            <h2>Orçamento</h2>
            <div className='dadosClienteModal'>
              <span><strong>Dados do cliente: </strong>{selectedCliente.colFantasia}</span>
              <span><strong>Pagamento: </strong>{paymentMethod}</span>
              <div>
                <strong>Parcelas: </strong>
                {paymentTerms
                  .filter((d) => d !== undefined && d !== null && d !== '')
                  .map((dias, index) => {
                    
                    return (
                      <span key={index}>
                        {dias} dias
                        {index < paymentTerms.filter(t => t && t !== '').length - 1 && ' , '}
                      </span>
                      
                    );
                  })
                }
              </div>
              <div>
                <strong>Vencimentos: </strong>
                {paymentTerms
                  .filter((d) => d !== undefined && d !== null && d !== '')
                  .length === 0 ? (
                    // Se não há prazos, mostra data de hoje (à vista)
                    <span>{new Date().toLocaleDateString('pt-BR')}</span>
                  ) : (
                    paymentTerms
                      .filter((d) => d !== undefined && d !== null && d !== '')
                      .map((dias, index) => {
                        const hoje = new Date();
                        const diasVencimento = parseInt(dias) || 0;
                        hoje.setDate(hoje.getDate() + diasVencimento);
                        const dataVencimento = hoje.toLocaleDateString('pt-BR');
                        
                        return (
                          <span key={index}>
                            {dataVencimento}
                            {index < paymentTerms.filter(t => t && t !== '').length - 1 && ' , '}
                          </span>
                        );
                      })
                  )
                }
              </div>
                {userInfo.controlaFlex === "T" && (
                  <div>
                    {(() => {
                      const totalFlex = orderItems.reduce((total, i) => {
                        const produto = produtos.find(p => p.proId === i.PRO_ID);
                        if (produto) {
                          const flexItem = (i.INFE_QTD_PRODUTO * i.INFE_VLR_PRODUTO) - (i.INFE_QTD_PRODUTO * (userInfo.tabelaPreco === "T" && tabelaSelecionada
                          ? precosTabela[tabelaSelecionada]?.[produto.proId] ?? produto.proVlrVenda
                          : produto.proVlrVenda));
                          return total + flexItem;
                        }
                        return total;
                      }, 0);

                      return (
                        <span
                          className={`${totalFlex > 0 ? 'flex-positivo' : 'flex-negativo'}`}
                        >
                          <strong>
                            Flex deste Pedido: {totalFlex.toLocaleString("pt-BR", {style: "currency", currency: "BRL"})}
                          </strong>
                        </span>
                      );
                    })()}
                  </div>
                )}
            </div>
            <div className='blocoItensModal'>
              <h4>Produtos:</h4>
              <ul>
                {orderItems
                  .sort((a, b) => a.ordem - b.ordem)
                  .map((i, idx) => {
                    // Busca o produto correspondente
                    //const produto = produtos.find(p => p.proId === i.PRO_ID);

                    // Verifica se tabela de preço está ativa e selecionada
                    const valorExibido = i.INFE_VLR_PRODUTO;

                    return (
                      <li key={idx} className='listaProdModal'>
                        <span>{i.descricao} {i.INFE_DESC_COMPLEMENTAR}</span>
                        <span>{i.INFE_QTD_PRODUTO} {i.INFE_UNIDADE}</span>
                        <span>
                          R${valorExibido.toFixed(2)}
                        </span>
                      </li>
                    );
                  })
                }
              </ul>
            <div className='infoPedidoModal'>
              <h3 className='total'>Sub Total: R$ {(calcularTotalPedido()).toFixed(2) || 0}</h3>
              {userInfo.descontoPedido === "T" && (<p className='subtotal'>Desconto Pedido: R$ {(parseFloat(desconto) || 0).toFixed(2)}</p>)}
              {userInfo.descontoFinanceiro === "T" && (<p className='subtotal'>Desconto Boleto: R$ {(parseFloat(descontoBoleto) || 0).toFixed(2)}</p>)}
              {userInfo.taxaEntrega === "T" && (<p className='subtotal'>Taxa Entrega: R$ {(parseFloat(taxaEntrega) || 0).toFixed(2)}</p>)}
              <h3 className='total'>Total Pedido: R$ {(calcularTotalPedido() - Number(desconto || 0) + Number(taxaEntrega || 0)).toFixed(2)}</h3>
              <span><strong>Data de entrega: </strong> {formatarData(dataEntrega) || ''}</span>
              <span><strong>Observação: </strong> {NFE_OBS_PEDIDO || '.'}</span>
              <h4 className='alertaPDF'>Este documento não tem validade como pedido, é apenas um orçamento.</h4>
            </div>
            </div>
            <div className="modal-buttons no-print">
              <button className='btnVoltar' onClick={() => setShowModal(false)}>Voltar</button>
              <button className='btnPDF' onClick={gerarPDF}>🖨️ PDF</button>
              <button className='btnOrcamento' onClick={() => {salvarOrcamento(); setShowModal(false);}}>Salvar Orçamento</button>
              <button
                className={pedidoSelecionado ? 'btnEditar' : 'btnConfirmar'}
                onClick={pedidoSelecionado ? handleEditarPedido : enviarPedido}
                disabled={isSubmitting}
              >
                {isSubmitting
                  ? (pedidoSelecionado ? "Editando..." : "Enviando...")
                  : (pedidoSelecionado ? "Editar Pedido" : "Enviar Pedido")}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
    )}
  </>
  );
};

export default Venda;